import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IPattern } from './useGetTitlePeriod';

interface IPaginationParams {
  currentPage?: number;
  itemPerPage?: number;
  inputSearch?: string;
  selectiveProcess?: string;
  refetchOnMount?: boolean;
  id?: string;
  remove_pagination?: boolean;
  step_id?: string;
}

export interface ITitleTypeAndRulesProps {
  can_send_titles: boolean;
  max_attached: number;
  size_attached: number;
  orientation_to_send_of_title?: string;
  types: IPattern[];
}

const GetTitleTypesAndRules = async <T>(params?: IPaginationParams) => {
  const response = await configApi.get<T>(`candidate-area/steps/${params?.step_id}/attachment-rules/`);
  return response.data;
};

export const useGetTitleTypesAndRules = <T>(params?: IPaginationParams) => {
  return useQuery({
    queryKey: ['get_title_types_and_rules', params],
    queryFn: () => GetTitleTypesAndRules<T>(params),
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};
